var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg23(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_528_131)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_528_131",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_528_131",
    transform: "scale(0.02)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_528_131",
    width: 50,
    height: 50,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD1ElEQVR4nO2ZXahUVRTHT5mmFWSRYdKL9dAHBcFF0oiOZ60zt0v1YMQxvHP2Ol4vDVEEBVlhiI9a+iBFhNrHQ4EVJUS9RZ8kiAQh4kPSx6VAxHpJ6QMc+8vZd1+dMzPnYx/PvTPG+cN6mNmz196//bHW3nscp1atWrVq1aqVFIJgHiJuQvFOKNo1nMY7ofzxuK/9IVoPXQHh/RDGRWGKvkWwclEviNDWgXdObI229oIo+j57BHgfFG+bY9uXMytH+4GcyKb3Jpw5FhRvyAE5YQ+i2J9zkJAa1YIo/hFBsMC6I837b0BIa7RF7lLr+kGwAIp+qgrkd0TeiFUHnhq7HEKvQajdsTHbUPyq7YAg8kZ0H0qBKPoUwh9AaBMmxpZYNew4l2RvUvoo/o2Vz4mxJVD0ounTJ8VB1vMKm4aSfjyVGzaVP17a/3peUQkIWiPzofzbELkL+4Pwd/kgdLBv3chdqH23RubPKgjCxvVx7DZOfkXYWJ4oH7/3Ggj/VwDkDCJ3caLuBN8E4d/M8vshbUlXAyL0fFc0255sxL+zWEZmIGzckfTNO5Ll9NzsgSj/sa61/kKiPBq9tTBI07ula5A2dYFMzh5IvD+E3oTQMQi9h7BxZaI8WLkIiv7NX1r8T/ceQ+BeBUXvT/vmN9L2SWWbPU8mdOeBfFzaf9hYbmBnG4RX6c2cnkfaCFffXdZ/rHglQOjlApmdjpnPn5c5Y0HxxnQQ79lCPprujeYEfMhk9ikI74Xy3XO/EX9tDkjC4nAq1jARPwKhwx2DcxhCDxeqK/5aKD6ZsTT3pOaa7NMv/dkd94sDuYtt6sJ1L4PizWYmsvba6yVANEyh0axSUN4D5xJw31zk3dNbSfh4zghI5R1t+Vfry5Oid6H4awh9BqHd+thvlo4Jyx+m9OntfiDfZIfM+CqsG7oA80bPjzY9DqE/Mto7OhNozHLrd6I+0gsS0mThrFzG4vxiju/Td5VC9U7PZHg9e0I/d5VP9b9H6JeUzstQVUbtmSMJhJ+xrH8a4t03PYv8aNfgfJm+bsW7WT/SRdyqzEJao31H7lIIn7KfTT6ELVsu1ab4l47vNzqDUM/p2W5WPePjFfPdcUyOXjsYEMVflN9jvK3jBvp3Z4YfAEjGi0i+7dU+mnQ7osZdA4PQneiNOtYgQyEIfXUBS+slZ1jUcwu0sdAjZ1iEDf4yKPqrBMiR1P9DBqX4nm8ZdtuIfHaGTeYl8q1i+4LOIKQnnWHVNAw9re856SBTiPwHnYtBWOdeB8VPmJPtAf13muJ3IN66+CF80P2rVcv5H+ksVUbgTbwWMEkAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg23);
export default __webpack_public_path__ + "static/media/23.3dfba55b17df2df39c5a5386785637c0.svg";
export { ForwardRef as ReactComponent };